import { getDefaultLang } from "@cervval.js/common/src/i18n/languages";
import { DAYS } from "@cervval.js/common/src/tools/timestamps.tools";

const _en = {
    weekDays: {
        [DAYS.MONDAY]: "Monday",
        [DAYS.TUESDAY]: "Tuesday",
        [DAYS.WEDNESDAY]: "Wednesday",
        [DAYS.THURSDAY]: "Thursday",
        [DAYS.FRIDAY]: "Friday",
        [DAYS.SATURDAY]: "Saturday",
        [DAYS.SUNDAY]: "Sunday"
    }
};

export type I18nWeekShifts = typeof _en;

const _fr: I18nWeekShifts = {
    weekDays: {
        [DAYS.MONDAY]: "Lundi",
        [DAYS.TUESDAY]: "Mardi",
        [DAYS.WEDNESDAY]: "Mercredi",
        [DAYS.THURSDAY]: "Jeudi",
        [DAYS.FRIDAY]: "Vendredi",
        [DAYS.SATURDAY]: "Samedi",
        [DAYS.SUNDAY]: "Dimanche"
    }
};

/**
 * Return value in required language
 * @param lang Chosen lang
 * @returns 
 */
export function I18n(lang?: string): I18nWeekShifts {
    lang = lang ?? getDefaultLang();
    switch (lang) {
        case "en":
            return _en;
        case "fr":
        default:
            return _fr;
    }
}